import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';


import { PostSubmitModalComponent } from '../../../modals/post-submit-modal/post-submit-modal.component';

interface MenuItem {
    icon: string;
    label: string;
    link: string;
}

@Component({
    selector: 'app-right-sidebar',
    templateUrl: './right_sidebar.component.html',
    styleUrls: ['./right_sidebar.component.css']
})
export class RightSidebarComponent implements OnInit, AfterViewInit {
    @Input() Username: string;  // Input property to receive username

    @Input() UserID!: number;

    @ViewChild('rightSidebar', { static: false }) rightSidebar!: ElementRef;
    private lastScrollTop = 0;

    @ViewChild('sidebarContainer', { static: false }) sidebarContainer!: ElementRef;


    @ViewChild('sidebarContainer') sidebarRef!: ElementRef;         // The moving content
    @ViewChild('sidebarContainer') sidebarContainerRef!: ElementRef;

    @ViewChild('sidebarContent') sidebarContentRef!: ElementRef;

    @ViewChild('sidebarContent', { static: true }) sidebarContent!: ElementRef;

    sidebarHeight: number = 0;
    viewportHeight: number = 0;
    marginTop: number = 0;
    lastScrollY: number = 0;
    maxMarginTop: number = 0;

    pinnedBottom: boolean = false;
    pinnedTop: boolean = false;

    sidebarReset: boolean = false;
    sidebarAtBottom: boolean = false;
    sidebarAtTop: boolean = true;

    private containerTop = 0;      // container's top relative to the page
    private containerHeight = 0;   // height of the container
    private contentHeight = 0;     // height of the sidebar content
    private maxTranslate = 0;      // maximum vertical translation allowed

    private isFixed = false;

    //menuItems: MenuItem[];  // Array to hold menu items

    //@Output() postSubmitComplete = new EventEmitter<void>();
    //@Output() mediaUrlsChange = new EventEmitter<any[]>();
    //@Output() replyTypeChange = new EventEmitter<any>();
    //@Output() postContent = new EventEmitter<string>();
    //@Output() onSave = new EventEmitter<void>();

    showWhoToFollow: boolean = true;
    showTrendingTopics: boolean = true;
    showSponsoredPosts: boolean = true;

    sidebarPosition: number = 0; // Tracks the sidebar scrolling position


    constructor(
        private modalService: NgbModal,
        private router: Router
    ) {
        // Define menu items - this could instead be loaded from a service
    //    this.menuItems = [
    //        { icon: 'fa-house', label: 'Home', link: '/' },
    //        { icon: 'fa-compass', label: 'Explore', link: '/explore' },
    //        { icon: 'fa-bell', label: 'Notifications', link: '/notifications' },
    //        // Add more items as needed
    //    ];
    }

    ngOnInit(): void {
        // Additional initialization can be done here
    }

    ngAfterViewInit() {
        //    window.addEventListener("scroll", this.onScroll2.bind(this));

        // The container is the parent element of our sidebar.
        const container = (this.sidebarRef.nativeElement as HTMLElement).parentElement;
        if (!container) { return; }
        // Ensure the container is positioned relative:
        container.style.position = 'relative';


        //this.measurePositions();


    }

    // Toggle widget visibility dynamically
    toggleWidgetVisibility(widget: string, hasData: boolean) {
        switch (widget) {
            case 'whoToFollow':
                this.showWhoToFollow = hasData;
                break;
            case 'trendingTopics':
                this.showTrendingTopics = hasData;
                break;
            case 'sponsoredPosts':
                this.showSponsoredPosts = hasData;
                break;
        }
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScrollEvent(): void {
        /* Intentionally idle: the old marginTop + pinned-top/pinned-bottom logic used
           global position:fixed rules that pulled this rail out of the Bootstrap column.
           Use CSS sticky on .right_side_bar .sidebar-content instead. */
    }




    //@HostListener('window:resize', [])
    //onResize() {
    //    this.measurePositions();
    //}

    //private measurePositions(): void {
    //    const containerEl = this.sidebarContainerRef.nativeElement as HTMLElement;
    //    const contentEl = this.sidebarContentRef.nativeElement as HTMLElement;

    //    // Get container's top relative to the page:
    //    this.containerTop = containerEl.getBoundingClientRect().top + window.scrollY;
    //    // Get container's height:
    //    this.containerHeight = containerEl.offsetHeight;
    //    // Get the sidebar content's height:
    //    this.contentHeight = contentEl.offsetHeight;
    //    // Maximum translation allowed so that the content's bottom aligns with the container's bottom:
    //    this.maxTranslate = Math.max(0, this.contentHeight - this.containerHeight);
    //}

    //@HostListener("window:scroll", [])
    //onWindowScroll(): void {
    //    const scrollY = window.scrollY || document.documentElement.scrollTop;
    //    const contentEl = this.sidebarContentRef.nativeElement as HTMLElement;

    //    // Compute translation based on scroll position relative to container top
    //    let translation = scrollY - this.containerTop;
    //    if (translation < 0) {
    //        translation = 0;
    //    } else if (translation > this.maxTranslate) {
    //        translation = this.maxTranslate;
    //    }

    //    // Update the sidebar content:
    //    contentEl.style.position = 'absolute';
    //    contentEl.style.top = '0px';
    //    // No changes to left � we keep it as is.
    //    contentEl.style.transform = `translateY(-${translation}px)`;
    //}



    //onWindowScroll() {
    //    const sidebar = document.querySelector('.right-sidebar-container') as HTMLElement;
    //    const postsContainer = document.querySelector('.main_bar') as HTMLElement;

    //    if (sidebar && postsContainer) {
    //        const postsBottom = postsContainer.getBoundingClientRect().bottom;
    //        const sidebarTop = sidebar.getBoundingClientRect().top;

    //        if (window.scrollY > this.sidebarPosition && sidebarTop > 0) {
    //            sidebar.style.position = "fixed";
    //            sidebar.style.top = "10px"; // Stick to top
    //        } else if (postsBottom < window.innerHeight) {
    //            sidebar.style.position = "absolute";
    //            sidebar.style.top = `${postsBottom - sidebar.clientHeight}px`;
    //        } else {
    //            sidebar.style.position = "relative";
    //        }

    //        this.sidebarPosition = window.scrollY;
    //    }
    //}

    //onScroll() {
    //    const sidebar = this.rightSidebar?.nativeElement;
    //    const postsContainer = document.querySelector('.main_bar') as HTMLElement;

    //    if (!sidebar || !postsContainer) return;

    //    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    //    const postsBottom = postsContainer.getBoundingClientRect().bottom;
    //    const sidebarHeight = sidebar.clientHeight;
    //    const windowHeight = window.innerHeight;

    //    if (scrollTop > this.lastScrollTop && sidebar.getBoundingClientRect().bottom > windowHeight) {
    //        sidebar.style.position = "fixed";
    //        sidebar.style.top = "10px";
    //    } else if (scrollTop < this.lastScrollTop && postsBottom > windowHeight + sidebarHeight) {
    //        sidebar.style.position = "relative";
    //    }

    //    this.lastScrollTop = scrollTop;
    //}

    //onScroll2() {
    //    const sidebar = this.sidebarContainer?.nativeElement;
    //    const postsContainer = document.querySelector('.main_bar') as HTMLElement;

    //    if (!sidebar || !postsContainer) return;

    //    const scrollY = window.scrollY || document.documentElement.scrollTop;
    //    const sidebarHeight = sidebar.clientHeight;
    //    const windowHeight = window.innerHeight;
    //    const postsBottom = postsContainer.getBoundingClientRect().bottom;

    //    // When scrolling down
    //    if (scrollY > this.lastScrollY) {
    //        if (!this.isFixed && sidebar.getBoundingClientRect().bottom > windowHeight) {
    //            sidebar.style.position = "fixed";
    //            sidebar.style.top = "10px";
    //            this.isFixed = true;
    //        }
    //    }

    //    // When scrolling up
    //    else {
    //        if (this.isFixed && postsBottom > sidebarHeight + windowHeight) {
    //            sidebar.style.position = "relative";
    //            this.isFixed = false;
    //        }
    //    }

    //    this.lastScrollY = scrollY;
    //}

    navigateToProfile(): void {
        this.router.navigate(['/', this.Username]);
    }

    isProfileActive(): boolean {
        return this.router.url === `/${this.Username}`;
    }

    refreshPosts() {
        // Emit the event to refresh posts
    //    this.postSubmitComplete.emit();
    }



}
